module.exports = __webpack_public_path__ + "static/006-3ebbaeacc68a62b107d37051e2350279.jpg";